// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from '@hey-api/client-fetch';
import type { GetCoreConfigGetCommonConfigData, GetCoreConfigGetCommonConfigResponse, PutCoreConfigSetCommonConfigData, PutCoreConfigSetCommonConfigResponse, GetCoreInstallsListData, GetCoreInstallsListResponse, GetCoreInstallsResolveNamesData, GetCoreInstallsResolveNamesResponse, GetCoreLocationsIndexData, GetCoreLocationsIndexResponse, PostCoreLocationsCreateData, PostCoreLocationsCreateResponse, DeleteCoreLocationsDeleteData, DeleteCoreLocationsDeleteResponse, PutCoreLocationsUpdateData, PutCoreLocationsUpdateResponse, PostCoreUploadsUploadData, PostCoreUploadsUploadResponse, PostCoreUploadsUploadFromScannerData, PostCoreUploadsUploadFromScannerResponse, PostCoreEtlExportData, PostCoreEtlImportData, PostCoreEtlImportResponse, GetCoreTagsIndexData, GetCoreTagsIndexResponse, PostCoreTagsCreateData, PostCoreTagsCreateResponse, DeleteCoreTagsDeleteData, DeleteCoreTagsDeleteResponse, PutCoreTagsUpdateData, PutCoreTagsUpdateResponse, GetCrmConfigFileCategoriesIndexData, GetCrmConfigFileCategoriesIndexResponse, PostCrmConfigFileCategoriesCreateData, PostCrmConfigFileCategoriesCreateResponse, DeleteCrmConfigFileCategoriesDeleteData, DeleteCrmConfigFileCategoriesDeleteResponse, PutCrmConfigFileCategoriesUpdateData, PutCrmConfigFileCategoriesUpdateResponse, GetCrmContactsIndexData, GetCrmContactsIndexResponse, PostCrmContactsCreateData, PostCrmContactsCreateResponse, DeleteCrmContactsDeleteData, DeleteCrmContactsDeleteResponse, GetCrmContactsShowData, GetCrmContactsShowResponse, PutCrmContactsUpdateData, PutCrmContactsUpdateResponse, GetCrmContactsExportExportData, GetCrmContactNotesIndexData, GetCrmContactNotesIndexResponse, PostCrmContactNotesCreateData, PostCrmContactNotesCreateResponse, DeleteCrmContactNotesDeleteData, DeleteCrmContactNotesDeleteResponse, PutCrmContactNotesUpdateData, PutCrmContactNotesUpdateResponse, GetCrmContactFilesIndexData, GetCrmContactFilesIndexResponse, PostCrmContactFilesCreateData, PostCrmContactFilesCreateResponse, GetCrmContactFilesDownloadData, GetCrmContactFilesDownloadResponse, DeleteCrmContactFilesDeleteData, DeleteCrmContactFilesDeleteResponse, PutCrmContactFilesUpdateData, PutCrmContactFilesUpdateResponse, GetCrmContactPaymentMethodsIndexData, GetCrmContactPaymentMethodsIndexResponse, PostCrmContactPaymentMethodsCreateData, PostCrmContactPaymentMethodsCreateResponse, PostCrmContactPaymentMethodsSetupData, PostCrmContactPaymentMethodsSetupResponse, PostCrmContactPaymentMethodsCreateViaTerminalData, PostCrmContactPaymentMethodsCreateViaTerminalResponse, DeleteCrmContactPaymentMethodsDeleteData, DeleteCrmContactPaymentMethodsDeleteResponse, PostCrmHelpersParseAddressData, PostCrmHelpersParseAddressResponse, PostCrmPublicSendEmailVerifyData, PostCrmPublicSendEmailVerifyResponse, PostCrmPublicConfirmEmailVerifyData, PostCrmPublicConfirmEmailVerifyResponse, GetDisplayDevicesListData, GetDisplayDevicesListResponse, PostDisplayDevicesRegisterData, PostDisplayDevicesRegisterResponse, PutDisplayDevicesUpdateDeviceData, PutDisplayDevicesUpdateDeviceResponse, GetFormsListFormsData, GetFormsListFormsResponse, GetFormsPublicGetFormData, GetFormsPublicGetFormResponse, PostFormsPublicSubmitFormData, PostFormsPublicSubmitFormResponse, PostFormsPublicResolveZipData, PostFormsPublicResolveZipResponse, GetFormSubmissionsGetSubmissionsData, GetFormSubmissionsGetSubmissionsResponse, GetFormSubmissionsGetSubmissionRenderHtmlData, GetFormSubmissionsGetSubmissionRenderHtmlResponse, GetFormSubmissionsGetSubmissionRenderPdfData, GetFormSubmissionsGetSubmissionRenderPdfResponse, GetInventoryCategoriesIndexData, GetInventoryCategoriesIndexResponse, PostInventoryCategoriesCreateData, PostInventoryCategoriesCreateResponse, GetInventoryItemsIndexData, GetInventoryItemsIndexResponse, PostInventoryItemsCreateData, PostInventoryItemsCreateResponse, DeleteInventoryItemsDeleteItemData, GetInventoryItemsGetData, GetInventoryItemsGetResponse, PutInventoryItemsUpdateData, PutInventoryItemsUpdateResponse, PostInventoryItemsPrintLabelData, PostInventoryItemsPrintLabelResponse, PostInventoryItemsImportResolveData, PostInventoryItemsImportResolveResponse, PostInventoryItemsImportImportData, PostInventoryItemsImportImportResponse, GetInventoryVendorsIndexData, GetInventoryVendorsIndexResponse, PostInventoryVendorsCreateData, PostInventoryVendorsCreateResponse, GetItFreshdeskBridgePublicGetConfigData, GetItFreshdeskBridgePublicGetConfigResponse, PostItFreshdeskBridgePublicSubmitFormData, PostItFreshdeskBridgePublicSubmitFormResponse, GetItFreshdeskBridgePublicStartSsoData, GetItFreshdeskBridgePublicStartSsoResponse, PostItFreshdeskBridgePublicGenerateSsoTokenData, PostItFreshdeskBridgePublicGenerateSsoTokenResponse, GetSalesCashDrawersGetCashDrawersData, GetSalesCashDrawersGetCashDrawersResponse, GetSalesCashDrawersListSessionsData, GetSalesCashDrawersListSessionsResponse, PostSalesCashDrawersOpenSessionData, PostSalesCashDrawersOpenSessionResponse, GetSalesCashDrawersGetCurrentSessionData, GetSalesCashDrawersGetCurrentSessionResponse, GetSalesCashDrawersGetSessionData, GetSalesCashDrawersGetSessionResponse, GetSalesCashDrawersGetExpectedCashData, GetSalesCashDrawersGetExpectedCashResponse, PostSalesCashDrawersRecordCloseoutData, PostSalesCashDrawersRecordCloseoutResponse, GetSalesConfigBookableTypesIndexData, GetSalesConfigBookableTypesIndexResponse, PostSalesConfigBookableTypesCreateData, PostSalesConfigBookableTypesCreateResponse, DeleteSalesConfigBookableTypesDeleteData, DeleteSalesConfigBookableTypesDeleteResponse, PutSalesConfigBookableTypesUpdateData, PutSalesConfigBookableTypesUpdateResponse, GetSalesConfigCustomPaymentMethodsIndexData, GetSalesConfigCustomPaymentMethodsIndexResponse, PostSalesConfigCustomPaymentMethodsCreateData, PostSalesConfigCustomPaymentMethodsCreateResponse, DeleteSalesConfigCustomPaymentMethodsDeleteData, DeleteSalesConfigCustomPaymentMethodsDeleteResponse, PutSalesConfigCustomPaymentMethodsUpdateData, PutSalesConfigCustomPaymentMethodsUpdateResponse, GetSalesConfigPaymentAccountsIndexData, GetSalesConfigPaymentAccountsIndexResponse, PostSalesConfigPaymentAccountsCreateData, PostSalesConfigPaymentAccountsCreateResponse, PostSalesConfigPaymentAccountsCreateWithOauthCodeData, PostSalesConfigPaymentAccountsCreateWithOauthCodeResponse, GetSalesConfigPaymentOverviewIndexData, GetSalesConfigPaymentOverviewIndexResponse, GetSalesConfigPaymentTerminalsIndexData, GetSalesConfigPaymentTerminalsIndexResponse, PostSalesConfigPaymentTerminalsCreateData, PostSalesConfigPaymentTerminalsCreateResponse, DeleteSalesConfigPaymentTerminalsDeleteData, DeleteSalesConfigPaymentTerminalsDeleteResponse, PutSalesConfigPaymentTerminalsUpdateData, PutSalesConfigPaymentTerminalsUpdateResponse, PostSalesConfigPaymentTerminalsClearData, PostSalesConfigPaymentTerminalsClearResponse, PostSalesConfigPaymentTerminalsCreateConnectionTokenData, PostSalesConfigPaymentTerminalsCreateConnectionTokenResponse, PostSalesConfigPaymentTerminalsLocationsCreateData, PostSalesConfigPaymentTerminalsLocationsCreateResponse, GetSalesConfigProductCategoriesIndexData, GetSalesConfigProductCategoriesIndexResponse, PostSalesConfigProductCategoriesCreateData, PostSalesConfigProductCategoriesCreateResponse, DeleteSalesConfigProductCategoriesDeleteData, DeleteSalesConfigProductCategoriesDeleteResponse, PutSalesConfigProductCategoriesUpdateData, PutSalesConfigProductCategoriesUpdateResponse, GetSalesConfigProductModifiersIndexData, GetSalesConfigProductModifiersIndexResponse, PostSalesConfigProductModifiersCreateData, PostSalesConfigProductModifiersCreateResponse, DeleteSalesConfigProductModifiersDeleteData, DeleteSalesConfigProductModifiersDeleteResponse, GetSalesConfigProductModifiersGetData, GetSalesConfigProductModifiersGetResponse, PatchSalesConfigProductModifiersUpdateData, PatchSalesConfigProductModifiersUpdateResponse, GetSalesConfigTaxesIndexData, GetSalesConfigTaxesIndexResponse, GetSalesPredefinedDiscountTypesIndexData, GetSalesPredefinedDiscountTypesIndexResponse, PostSalesPredefinedDiscountTypesCreateData, PostSalesPredefinedDiscountTypesCreateResponse, DeleteSalesPredefinedDiscountTypesDeleteData, DeleteSalesPredefinedDiscountTypesDeleteResponse, PutSalesPredefinedDiscountTypesUpdateData, PutSalesPredefinedDiscountTypesUpdateResponse, GetSalesFinancialAccountsIndexData, GetSalesFinancialAccountsIndexResponse, PostSalesFinancialAccountsCreateData, PostSalesFinancialAccountsCreateResponse, DeleteSalesFinancialAccountsDeleteData, DeleteSalesFinancialAccountsDeleteResponse, PutSalesFinancialAccountsUpdateData, PutSalesFinancialAccountsUpdateResponse, GetSalesFinancialDailyCloseoutsIndexData, GetSalesFinancialDailyCloseoutsIndexResponse, GetSalesFinancialTransactionsIndexData, GetSalesFinancialTransactionsIndexResponse, PostSalesFulfillmentAddressVerificationVerifyAddressData, PostSalesFulfillmentAddressVerificationVerifyAddressResponse, GetSalesFulfillmentConfigGetData, GetSalesFulfillmentConfigGetResponse, PutSalesFulfillmentConfigUpdateData, PutSalesFulfillmentConfigUpdateResponse, GetSalesFulfillmentBoxTypesListData, GetSalesFulfillmentBoxTypesListResponse, PostSalesFulfillmentBoxTypesCreateData, PostSalesFulfillmentBoxTypesCreateResponse, GetSalesFulfillmentBoxTypesListPredefinedData, GetSalesFulfillmentBoxTypesListPredefinedResponse, DeleteSalesFulfillmentBoxTypesDeleteData, DeleteSalesFulfillmentBoxTypesDeleteResponse, PostSalesFulfillmentBoxTypesUpdateData, PostSalesFulfillmentBoxTypesUpdateResponse, PostSalesFulfillmentEasyPostWebhookPublicPostData, PostSalesFulfillmentEasyPostWebhookPublicPostResponse, PutSalesFulfillmentOrdersUpdateFulfillmentData, PutSalesFulfillmentOrdersUpdateFulfillmentResponse, GetSalesFulfillmentShipmentBatchesGetBatchesData, GetSalesFulfillmentShipmentBatchesGetBatchesResponse, PostSalesFulfillmentShipmentBatchesCreateBatchData, PostSalesFulfillmentShipmentBatchesCreateBatchResponse, DeleteSalesFulfillmentShipmentBatchesRemoveOrdersFromBatchData, DeleteSalesFulfillmentShipmentBatchesRemoveOrdersFromBatchResponse, PostSalesFulfillmentShipmentBatchesAddOrdersToBatchData, PostSalesFulfillmentShipmentBatchesAddOrdersToBatchResponse, GetSalesFulfillmentShipmentBatchesGetPackingSlipsData, GetSalesFulfillmentShipmentPickupsGetPickupsData, GetSalesFulfillmentShipmentPickupsGetPickupsResponse, PostSalesFulfillmentShipmentPickupsAddShipmentByBarcodeData, PostSalesFulfillmentShipmentPickupsAddShipmentByBarcodeResponse, PostSalesFulfillmentShipmentPickupsAddShipmentByIdData, PostSalesFulfillmentShipmentPickupsAddShipmentByIdResponse, PostSalesFulfillmentShippingCalculatorCalculateShippingData, PostSalesFulfillmentShippingCalculatorCalculateShippingResponse, PostSalesFulfillmentShippingCalculatorRecalculateShippingData, PostSalesFulfillmentShippingCalculatorRecalculateShippingResponse, GetSalesFulfillmentShippingLabelGetPackingSlipData, GetSalesFulfillmentShippingLabelGetLabelData, PostSalesFulfillmentShippingLabelPurchaseLabelData, PostSalesFulfillmentShippingLabelPurchaseLabelResponse, PostSalesFulfillmentShippingLabelPrintLabelData, PostSalesFulfillmentShippingLabelPrintLabelResponse, PostSalesFulfillmentShippingLabelRefundLabelData, PostSalesFulfillmentShippingLabelRefundLabelResponse, GetSalesGiftCardsIndexData, GetSalesGiftCardsIndexResponse, GetSalesGiftCardsLookupData, GetSalesGiftCardsLookupResponse, PostSalesGiftCardsDeliverData, PostSalesGiftCardsDeliverResponse, GetSalesGiftCardsPublicRenderRenderGiftCardData, GetSalesGiftCardsPublicRenderRenderGiftCardEmailData, DeleteSalesIntegrationsQboConnectionsDeleteIntegrationData, DeleteSalesIntegrationsQboConnectionsDeleteIntegrationResponse, GetSalesIntegrationsQboConnectionsGetIntegrationsData, GetSalesIntegrationsQboConnectionsGetIntegrationsResponse, PostSalesIntegrationsQboConnectionsCreateIntegrationData, PostSalesIntegrationsQboConnectionsCreateIntegrationResponse, PutSalesIntegrationsQboConnectionsUpdateIntegrationData, PutSalesIntegrationsQboConnectionsUpdateIntegrationResponse, GetSalesIntegrationsQboConnectionsGetQboAccountsData, GetSalesIntegrationsQboConnectionsGetQboAccountsResponse, GetSalesLayoutsGetDefaultData, GetSalesLayoutsGetDefaultResponse, GetSalesMembershipCreditPoolsIndexData, GetSalesMembershipCreditPoolsIndexResponse, PostSalesMembershipCreditPoolsCreateData, PostSalesMembershipCreditPoolsCreateResponse, DeleteSalesMembershipCreditPoolsDeleteData, DeleteSalesMembershipCreditPoolsDeleteResponse, GetSalesMembershipCreditPoolsShowData, GetSalesMembershipCreditPoolsShowResponse, PutSalesMembershipCreditPoolsUpdateData, PutSalesMembershipCreditPoolsUpdateResponse, GetSalesMembershipTypeCreditPoolGrantsIndexData, GetSalesMembershipTypeCreditPoolGrantsIndexResponse, PostSalesMembershipTypeCreditPoolGrantsCreateData, PostSalesMembershipTypeCreditPoolGrantsCreateResponse, DeleteSalesMembershipTypeCreditPoolGrantsDeleteData, DeleteSalesMembershipTypeCreditPoolGrantsDeleteResponse, GetSalesMembershipTypeCreditPoolGrantsShowData, GetSalesMembershipTypeCreditPoolGrantsShowResponse, PutSalesMembershipTypeCreditPoolGrantsUpdateData, PutSalesMembershipTypeCreditPoolGrantsUpdateResponse, GetSalesMembershipTypeDiscountsIndexData, GetSalesMembershipTypeDiscountsIndexResponse, PostSalesMembershipTypeDiscountsCreateData, PostSalesMembershipTypeDiscountsCreateResponse, DeleteSalesMembershipTypeDiscountsDeleteData, DeleteSalesMembershipTypeDiscountsDeleteResponse, GetSalesMembershipTypeDiscountsShowData, GetSalesMembershipTypeDiscountsShowResponse, PutSalesMembershipTypeDiscountsUpdateData, PutSalesMembershipTypeDiscountsUpdateResponse, GetSalesMembershipTypesIndexData, GetSalesMembershipTypesIndexResponse, GetSalesMembershipTypesShowData, GetSalesMembershipTypesShowResponse, GetSalesProductsIndexData, GetSalesProductsIndexResponse, PostSalesProductsCreateData, PostSalesProductsCreateResponse, DeleteSalesProductsDeleteData, DeleteSalesProductsDeleteResponse, GetSalesProductsShowData, GetSalesProductsShowResponse, PutSalesProductsUpdateData, PutSalesProductsUpdateResponse, GetSalesEcommProductsPublicIndexData, GetSalesEcommProductsPublicIndexResponse, GetSalesEcommProductsPublicShowData, GetSalesEcommProductsPublicShowResponse, GetSalesSalespointsGetSelfData, GetSalesSalespointsGetSelfResponse, PostSalesSalespointsOpenDrawerData, PostSalesSalespointsOpenDrawerResponse, GetSalesBookingSummaryGetBookingsData, GetSalesBookingSummaryGetBookingsResponse, GetSalesTabsListData, GetSalesTabsListResponse, DeleteSalesTabsDeleteTabData, DeleteSalesTabsDeleteTabResponse, GetSalesTabsGetData, GetSalesTabsGetResponse, PutSalesTabsUpdateTabData, PutSalesTabsUpdateTabResponse, PostSalesTabsCreateItemData, PostSalesTabsCreateItemResponse, DeleteSalesTabsDeleteItemData, DeleteSalesTabsDeleteItemResponse, PutSalesTabsUpdateItemData, PutSalesTabsUpdateItemResponse, PostSalesTabsTouchData, PostSalesTabsTouchResponse, GetSalesTabsExportExportData, PostSalesTabPaymentsSetupCcPaymentIntentData, PostSalesTabPaymentsSetupCcPaymentIntentResponse, PostSalesTabPaymentsSetupCcTerminalPaymentIntentData, PostSalesTabPaymentsSetupCcTerminalPaymentIntentResponse, PostSalesTabPaymentsConfirmPaymentIntentData, PostSalesTabPaymentsConfirmPaymentIntentResponse, PostSalesTabPaymentsPayWithConfirmationTokenData, PostSalesTabPaymentsPayWithConfirmationTokenResponse, PostSalesTabPaymentsPayWithMethodData, PostSalesTabPaymentsPayWithMethodResponse, PostSalesTabPaymentsPayWithCashData, PostSalesTabPaymentsPayWithCashResponse, PostSalesTabPaymentsPayWithCheckData, PostSalesTabPaymentsPayWithCheckResponse, PostSalesTabPaymentsPayWithGiftCardData, PostSalesTabPaymentsPayWithGiftCardResponse, PostSalesTabPaymentsPayWithCustomData, PostSalesTabPaymentsPayWithCustomResponse, PostSalesTabPaymentsRefundPaymentData, PostSalesTabPaymentsRefundPaymentResponse, PostSalesTabPaymentsFinalizeZeroRemainderTabData, PostSalesTabPaymentsFinalizeZeroRemainderTabResponse, PostSalesTabPaymentsCapturePaymentData, PostSalesTabPaymentsCapturePaymentResponse, GetSalesTabReceiptsGetAuthenticatedReceiptData, PostSalesTabReceiptsSendReceiptData, PostSalesTabReceiptsSendReceiptResponse, GetSalesTabReceiptsGetPublicReceiptByTokenData, GetSalesTabReceiptsGetPublicReceiptData, GetSalesTabReceiptsGetPublicReceiptPdfData, PostSalesTabPostSaleUpdatesOpenRevisionData, PostSalesTabPostSaleUpdatesOpenRevisionResponse, PostSalesTabPostSaleUpdatesFinalizeRevisionData, PostSalesTabPostSaleUpdatesFinalizeRevisionResponse, PostSalesTabPostSaleUpdatesRevertRevisionData, PostSalesTabPostSaleUpdatesRevertRevisionResponse, PostSalesTabPostSaleUpdatesRefundTabData, PostSalesTabPostSaleUpdatesRefundTabResponse, PostSalesTabPostSaleUpdatesAdjustTabData, PostSalesTabPostSaleUpdatesAdjustTabResponse, PostSalesStripeWebhookPublicHandleData, PostSalesReportsGetDataData, PostSalesReportsGetDataResponse, GetSalesXCrmMembershipsIndexData, GetSalesXCrmMembershipsIndexResponse, GetSalesXCrmMembershipsContactIndexData, GetSalesXCrmMembershipsContactIndexResponse, PutSalesXCrmMembershipsUpdateData, PutSalesXCrmMembershipsUpdateResponse, PostSalesXCrmMembershipsPreviewChangeData, PostSalesXCrmMembershipsPreviewChangeResponse, GetSalesXCrmMembershipsGetRenewalsData, GetSalesXCrmMembershipsGetRenewalsResponse, GetSalesXCrmMembershipsGetDiscountDetailData, GetSalesXCrmMembershipsGetDiscountDetailResponse, GetSalesXCrmMembershipsGetCreditPoolDetailData, GetSalesXCrmMembershipsGetCreditPoolDetailResponse, PutSalesXCrmMembershipsUpdateDiscountPeriodDiscountData, PutSalesXCrmMembershipsUpdateDiscountPeriodDiscountResponse, PutSalesXCrmMembershipsUpdateCreditPoolBalanceData, PutSalesXCrmMembershipsUpdateCreditPoolBalanceResponse, GetHealthcheckIndexData, GetHealthcheckIndexResponse } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export class CoreConfigApi {
    public static getCoreConfigGetCommonConfig<ThrowOnError extends boolean = false>(options?: Options<GetCoreConfigGetCommonConfigData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetCoreConfigGetCommonConfigResponse, unknown, ThrowOnError>({
            url: '/config/common',
            ...options
        });
    }
    
    public static putCoreConfigSetCommonConfig<ThrowOnError extends boolean = false>(options: Options<PutCoreConfigSetCommonConfigData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutCoreConfigSetCommonConfigResponse, unknown, ThrowOnError>({
            url: '/config/common',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class CoreInstallsApi {
    public static getCoreInstallsList<ThrowOnError extends boolean = false>(options?: Options<GetCoreInstallsListData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetCoreInstallsListResponse, unknown, ThrowOnError>({
            url: '/core/installs',
            ...options
        });
    }
    
    public static getCoreInstallsResolveNames<ThrowOnError extends boolean = false>(options: Options<GetCoreInstallsResolveNamesData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetCoreInstallsResolveNamesResponse, unknown, ThrowOnError>({
            url: '/core/installs/resolve-names',
            ...options
        });
    }
    
}

export class CoreLocationsApi {
    public static getCoreLocationsIndex<ThrowOnError extends boolean = false>(options?: Options<GetCoreLocationsIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetCoreLocationsIndexResponse, unknown, ThrowOnError>({
            url: '/core/locations',
            ...options
        });
    }
    
    public static postCoreLocationsCreate<ThrowOnError extends boolean = false>(options: Options<PostCoreLocationsCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostCoreLocationsCreateResponse, unknown, ThrowOnError>({
            url: '/core/locations',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static deleteCoreLocationsDelete<ThrowOnError extends boolean = false>(options: Options<DeleteCoreLocationsDeleteData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteCoreLocationsDeleteResponse, unknown, ThrowOnError>({
            url: '/core/locations/{id}',
            ...options
        });
    }
    
    public static putCoreLocationsUpdate<ThrowOnError extends boolean = false>(options: Options<PutCoreLocationsUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutCoreLocationsUpdateResponse, unknown, ThrowOnError>({
            url: '/core/locations/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class CoreUploadsApi {
    public static postCoreUploadsUpload<ThrowOnError extends boolean = false>(options: Options<PostCoreUploadsUploadData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostCoreUploadsUploadResponse, unknown, ThrowOnError>({
            url: '/core/uploads',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postCoreUploadsUploadFromScanner<ThrowOnError extends boolean = false>(options: Options<PostCoreUploadsUploadFromScannerData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostCoreUploadsUploadFromScannerResponse, unknown, ThrowOnError>({
            url: '/core/uploads/from-scanner',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class CoreEtlApi {
    public static postCoreEtlExport<ThrowOnError extends boolean = false>(options?: Options<PostCoreEtlExportData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
            url: '/core/etl/export',
            ...options
        });
    }
    
    public static postCoreEtlImport<ThrowOnError extends boolean = false>(options?: Options<PostCoreEtlImportData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).post<PostCoreEtlImportResponse, unknown, ThrowOnError>({
            url: '/core/etl/import',
            ...options
        });
    }
    
}

export class CoreTagsApi {
    public static getCoreTagsIndex<ThrowOnError extends boolean = false>(options: Options<GetCoreTagsIndexData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetCoreTagsIndexResponse, unknown, ThrowOnError>({
            url: '/tags/{module}',
            ...options
        });
    }
    
    public static postCoreTagsCreate<ThrowOnError extends boolean = false>(options: Options<PostCoreTagsCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostCoreTagsCreateResponse, unknown, ThrowOnError>({
            url: '/tags/{module}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static deleteCoreTagsDelete<ThrowOnError extends boolean = false>(options: Options<DeleteCoreTagsDeleteData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteCoreTagsDeleteResponse, unknown, ThrowOnError>({
            url: '/tags/{module}/{id}',
            ...options
        });
    }
    
    public static putCoreTagsUpdate<ThrowOnError extends boolean = false>(options: Options<PutCoreTagsUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutCoreTagsUpdateResponse, unknown, ThrowOnError>({
            url: '/tags/{module}/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class CrmConfigFileCategoriesApi {
    public static getCrmConfigFileCategoriesIndex<ThrowOnError extends boolean = false>(options?: Options<GetCrmConfigFileCategoriesIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetCrmConfigFileCategoriesIndexResponse, unknown, ThrowOnError>({
            url: '/crm/config/file-categories',
            ...options
        });
    }
    
    public static postCrmConfigFileCategoriesCreate<ThrowOnError extends boolean = false>(options: Options<PostCrmConfigFileCategoriesCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostCrmConfigFileCategoriesCreateResponse, unknown, ThrowOnError>({
            url: '/crm/config/file-categories',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static deleteCrmConfigFileCategoriesDelete<ThrowOnError extends boolean = false>(options: Options<DeleteCrmConfigFileCategoriesDeleteData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteCrmConfigFileCategoriesDeleteResponse, unknown, ThrowOnError>({
            url: '/crm/config/file-categories/{id}',
            ...options
        });
    }
    
    public static putCrmConfigFileCategoriesUpdate<ThrowOnError extends boolean = false>(options: Options<PutCrmConfigFileCategoriesUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutCrmConfigFileCategoriesUpdateResponse, unknown, ThrowOnError>({
            url: '/crm/config/file-categories/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class CrmContactsApi {
    public static getCrmContactsIndex<ThrowOnError extends boolean = false>(options?: Options<GetCrmContactsIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetCrmContactsIndexResponse, unknown, ThrowOnError>({
            url: '/crm/contacts',
            ...options
        });
    }
    
    public static postCrmContactsCreate<ThrowOnError extends boolean = false>(options: Options<PostCrmContactsCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostCrmContactsCreateResponse, unknown, ThrowOnError>({
            url: '/crm/contacts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static deleteCrmContactsDelete<ThrowOnError extends boolean = false>(options: Options<DeleteCrmContactsDeleteData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteCrmContactsDeleteResponse, unknown, ThrowOnError>({
            url: '/crm/contacts/{id}',
            ...options
        });
    }
    
    public static getCrmContactsShow<ThrowOnError extends boolean = false>(options: Options<GetCrmContactsShowData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetCrmContactsShowResponse, unknown, ThrowOnError>({
            url: '/crm/contacts/{id}',
            ...options
        });
    }
    
    public static putCrmContactsUpdate<ThrowOnError extends boolean = false>(options: Options<PutCrmContactsUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutCrmContactsUpdateResponse, unknown, ThrowOnError>({
            url: '/crm/contacts/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class CrmContactsExportApi {
    public static getCrmContactsExportExport<ThrowOnError extends boolean = false>(options?: Options<GetCrmContactsExportExportData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
            url: '/crm/contacts/export',
            ...options
        });
    }
    
}

export class CrmContactNotesApi {
    public static getCrmContactNotesIndex<ThrowOnError extends boolean = false>(options: Options<GetCrmContactNotesIndexData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetCrmContactNotesIndexResponse, unknown, ThrowOnError>({
            url: '/crm/contacts/{contactId}/notes',
            ...options
        });
    }
    
    public static postCrmContactNotesCreate<ThrowOnError extends boolean = false>(options: Options<PostCrmContactNotesCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostCrmContactNotesCreateResponse, unknown, ThrowOnError>({
            url: '/crm/contacts/{contactId}/notes',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static deleteCrmContactNotesDelete<ThrowOnError extends boolean = false>(options: Options<DeleteCrmContactNotesDeleteData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteCrmContactNotesDeleteResponse, unknown, ThrowOnError>({
            url: '/crm/contacts/{contactId}/notes/{id}',
            ...options
        });
    }
    
    public static putCrmContactNotesUpdate<ThrowOnError extends boolean = false>(options: Options<PutCrmContactNotesUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutCrmContactNotesUpdateResponse, unknown, ThrowOnError>({
            url: '/crm/contacts/{contactId}/notes/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class CrmContactFilesApi {
    public static getCrmContactFilesIndex<ThrowOnError extends boolean = false>(options: Options<GetCrmContactFilesIndexData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetCrmContactFilesIndexResponse, unknown, ThrowOnError>({
            url: '/crm/contacts/{contactId}/files',
            ...options
        });
    }
    
    public static postCrmContactFilesCreate<ThrowOnError extends boolean = false>(options: Options<PostCrmContactFilesCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostCrmContactFilesCreateResponse, unknown, ThrowOnError>({
            url: '/crm/contacts/{contactId}/files',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static getCrmContactFilesDownload<ThrowOnError extends boolean = false>(options: Options<GetCrmContactFilesDownloadData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetCrmContactFilesDownloadResponse, unknown, ThrowOnError>({
            url: '/crm/contacts/{contactId}/files/{id}/download',
            ...options
        });
    }
    
    public static deleteCrmContactFilesDelete<ThrowOnError extends boolean = false>(options: Options<DeleteCrmContactFilesDeleteData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteCrmContactFilesDeleteResponse, unknown, ThrowOnError>({
            url: '/crm/contacts/{contactId}/files/{id}',
            ...options
        });
    }
    
    public static putCrmContactFilesUpdate<ThrowOnError extends boolean = false>(options: Options<PutCrmContactFilesUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutCrmContactFilesUpdateResponse, unknown, ThrowOnError>({
            url: '/crm/contacts/{contactId}/files/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class CrmContactPaymentMethodsApi {
    public static getCrmContactPaymentMethodsIndex<ThrowOnError extends boolean = false>(options: Options<GetCrmContactPaymentMethodsIndexData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetCrmContactPaymentMethodsIndexResponse, unknown, ThrowOnError>({
            url: '/crm/contacts/{contactId}/payment-methods',
            ...options
        });
    }
    
    public static postCrmContactPaymentMethodsCreate<ThrowOnError extends boolean = false>(options: Options<PostCrmContactPaymentMethodsCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostCrmContactPaymentMethodsCreateResponse, unknown, ThrowOnError>({
            url: '/crm/contacts/{contactId}/payment-methods',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postCrmContactPaymentMethodsSetup<ThrowOnError extends boolean = false>(options: Options<PostCrmContactPaymentMethodsSetupData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostCrmContactPaymentMethodsSetupResponse, unknown, ThrowOnError>({
            url: '/crm/contacts/{contactId}/payment-methods/setup',
            ...options
        });
    }
    
    public static postCrmContactPaymentMethodsCreateViaTerminal<ThrowOnError extends boolean = false>(options: Options<PostCrmContactPaymentMethodsCreateViaTerminalData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostCrmContactPaymentMethodsCreateViaTerminalResponse, unknown, ThrowOnError>({
            url: '/crm/contacts/{contactId}/payment-methods/setup/via-terminal',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static deleteCrmContactPaymentMethodsDelete<ThrowOnError extends boolean = false>(options: Options<DeleteCrmContactPaymentMethodsDeleteData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteCrmContactPaymentMethodsDeleteResponse, unknown, ThrowOnError>({
            url: '/crm/contacts/{contactId}/payment-methods/{id}',
            ...options
        });
    }
    
}

export class CrmHelpersApi {
    public static postCrmHelpersParseAddress<ThrowOnError extends boolean = false>(options: Options<PostCrmHelpersParseAddressData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostCrmHelpersParseAddressResponse, unknown, ThrowOnError>({
            url: '/crm/helpers/parse-address',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class CrmPublicApi {
    public static postCrmPublicSendEmailVerify<ThrowOnError extends boolean = false>(options: Options<PostCrmPublicSendEmailVerifyData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostCrmPublicSendEmailVerifyResponse, unknown, ThrowOnError>({
            url: '/public/crm/send-email-verify',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postCrmPublicConfirmEmailVerify<ThrowOnError extends boolean = false>(options: Options<PostCrmPublicConfirmEmailVerifyData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostCrmPublicConfirmEmailVerifyResponse, unknown, ThrowOnError>({
            url: '/public/crm/confirm-email-verify',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class DisplayDevicesApi {
    public static getDisplayDevicesList<ThrowOnError extends boolean = false>(options?: Options<GetDisplayDevicesListData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetDisplayDevicesListResponse, unknown, ThrowOnError>({
            url: '/display/devices',
            ...options
        });
    }
    
    public static postDisplayDevicesRegister<ThrowOnError extends boolean = false>(options: Options<PostDisplayDevicesRegisterData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostDisplayDevicesRegisterResponse, unknown, ThrowOnError>({
            url: '/display/devices',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static putDisplayDevicesUpdateDevice<ThrowOnError extends boolean = false>(options: Options<PutDisplayDevicesUpdateDeviceData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutDisplayDevicesUpdateDeviceResponse, unknown, ThrowOnError>({
            url: '/display/devices/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class FormsApi {
    public static getFormsListForms<ThrowOnError extends boolean = false>(options?: Options<GetFormsListFormsData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetFormsListFormsResponse, unknown, ThrowOnError>({
            url: '/forms',
            ...options
        });
    }
    
}

export class FormsPublicApi {
    public static getFormsPublicGetForm<ThrowOnError extends boolean = false>(options: Options<GetFormsPublicGetFormData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetFormsPublicGetFormResponse, unknown, ThrowOnError>({
            url: '/public/forms/{tenantId}/{id}',
            ...options
        });
    }
    
    public static postFormsPublicSubmitForm<ThrowOnError extends boolean = false>(options: Options<PostFormsPublicSubmitFormData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostFormsPublicSubmitFormResponse, unknown, ThrowOnError>({
            url: '/public/forms/{tenantId}/{formId}/{definitionId}/submissions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postFormsPublicResolveZip<ThrowOnError extends boolean = false>(options: Options<PostFormsPublicResolveZipData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostFormsPublicResolveZipResponse, unknown, ThrowOnError>({
            url: '/public/forms/{tenantId}/{id}/resolve-zip',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class FormSubmissionsApi {
    public static getFormSubmissionsGetSubmissions<ThrowOnError extends boolean = false>(options?: Options<GetFormSubmissionsGetSubmissionsData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetFormSubmissionsGetSubmissionsResponse, unknown, ThrowOnError>({
            url: '/forms/submissions',
            ...options
        });
    }
    
    public static getFormSubmissionsGetSubmissionRenderHtml<ThrowOnError extends boolean = false>(options: Options<GetFormSubmissionsGetSubmissionRenderHtmlData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetFormSubmissionsGetSubmissionRenderHtmlResponse, unknown, ThrowOnError>({
            url: '/forms/submissions/{id}/render-html',
            ...options
        });
    }
    
    public static getFormSubmissionsGetSubmissionRenderPdf<ThrowOnError extends boolean = false>(options: Options<GetFormSubmissionsGetSubmissionRenderPdfData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetFormSubmissionsGetSubmissionRenderPdfResponse, unknown, ThrowOnError>({
            url: '/forms/submissions/{id}/render-pdf',
            ...options
        });
    }
    
}

export class InventoryCategoriesApi {
    public static getInventoryCategoriesIndex<ThrowOnError extends boolean = false>(options?: Options<GetInventoryCategoriesIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetInventoryCategoriesIndexResponse, unknown, ThrowOnError>({
            url: '/inventory/categories',
            ...options
        });
    }
    
    public static postInventoryCategoriesCreate<ThrowOnError extends boolean = false>(options: Options<PostInventoryCategoriesCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostInventoryCategoriesCreateResponse, unknown, ThrowOnError>({
            url: '/inventory/categories',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class InventoryItemsApi {
    public static getInventoryItemsIndex<ThrowOnError extends boolean = false>(options?: Options<GetInventoryItemsIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetInventoryItemsIndexResponse, unknown, ThrowOnError>({
            url: '/inventory/items',
            ...options
        });
    }
    
    public static postInventoryItemsCreate<ThrowOnError extends boolean = false>(options: Options<PostInventoryItemsCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostInventoryItemsCreateResponse, unknown, ThrowOnError>({
            url: '/inventory/items',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static deleteInventoryItemsDeleteItem<ThrowOnError extends boolean = false>(options: Options<DeleteInventoryItemsDeleteItemData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
            url: '/inventory/items/{id}',
            ...options
        });
    }
    
    public static getInventoryItemsGet<ThrowOnError extends boolean = false>(options: Options<GetInventoryItemsGetData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetInventoryItemsGetResponse, unknown, ThrowOnError>({
            url: '/inventory/items/{id}',
            ...options
        });
    }
    
    public static putInventoryItemsUpdate<ThrowOnError extends boolean = false>(options: Options<PutInventoryItemsUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutInventoryItemsUpdateResponse, unknown, ThrowOnError>({
            url: '/inventory/items/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postInventoryItemsPrintLabel<ThrowOnError extends boolean = false>(options: Options<PostInventoryItemsPrintLabelData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostInventoryItemsPrintLabelResponse, unknown, ThrowOnError>({
            url: '/inventory/items/{id}/print-label',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class InventoryItemsImportApi {
    public static postInventoryItemsImportResolve<ThrowOnError extends boolean = false>(options: Options<PostInventoryItemsImportResolveData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostInventoryItemsImportResolveResponse, unknown, ThrowOnError>({
            url: '/inventory/items/import/resolve',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postInventoryItemsImportImport<ThrowOnError extends boolean = false>(options: Options<PostInventoryItemsImportImportData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostInventoryItemsImportImportResponse, unknown, ThrowOnError>({
            url: '/inventory/items/import',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class InventoryVendorsApi {
    public static getInventoryVendorsIndex<ThrowOnError extends boolean = false>(options?: Options<GetInventoryVendorsIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetInventoryVendorsIndexResponse, unknown, ThrowOnError>({
            url: '/inventory/vendors',
            ...options
        });
    }
    
    public static postInventoryVendorsCreate<ThrowOnError extends boolean = false>(options: Options<PostInventoryVendorsCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostInventoryVendorsCreateResponse, unknown, ThrowOnError>({
            url: '/inventory/vendors',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class ItFreshdeskBridgePublicApi {
    public static getItFreshdeskBridgePublicGetConfig<ThrowOnError extends boolean = false>(options: Options<GetItFreshdeskBridgePublicGetConfigData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetItFreshdeskBridgePublicGetConfigResponse, unknown, ThrowOnError>({
            url: '/public/it/freshdesk/bridge/config',
            ...options
        });
    }
    
    public static postItFreshdeskBridgePublicSubmitForm<ThrowOnError extends boolean = false>(options: Options<PostItFreshdeskBridgePublicSubmitFormData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostItFreshdeskBridgePublicSubmitFormResponse, unknown, ThrowOnError>({
            url: '/public/it/freshdesk/bridge/submit',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static getItFreshdeskBridgePublicStartSso<ThrowOnError extends boolean = false>(options: Options<GetItFreshdeskBridgePublicStartSsoData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetItFreshdeskBridgePublicStartSsoResponse, unknown, ThrowOnError>({
            url: '/public/it/freshdesk/bridge/sso/start',
            ...options
        });
    }
    
    public static postItFreshdeskBridgePublicGenerateSsoToken<ThrowOnError extends boolean = false>(options: Options<PostItFreshdeskBridgePublicGenerateSsoTokenData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostItFreshdeskBridgePublicGenerateSsoTokenResponse, unknown, ThrowOnError>({
            url: '/public/it/freshdesk/bridge/sso/generate-token',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SalesCashDrawersApi {
    public static getSalesCashDrawersGetCashDrawers<ThrowOnError extends boolean = false>(options?: Options<GetSalesCashDrawersGetCashDrawersData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesCashDrawersGetCashDrawersResponse, unknown, ThrowOnError>({
            url: '/sales/cash-drawers',
            ...options
        });
    }
    
    public static getSalesCashDrawersListSessions<ThrowOnError extends boolean = false>(options?: Options<GetSalesCashDrawersListSessionsData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesCashDrawersListSessionsResponse, unknown, ThrowOnError>({
            url: '/sales/cash-drawers/sessions',
            ...options
        });
    }
    
    public static postSalesCashDrawersOpenSession<ThrowOnError extends boolean = false>(options: Options<PostSalesCashDrawersOpenSessionData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesCashDrawersOpenSessionResponse, unknown, ThrowOnError>({
            url: '/sales/cash-drawers/sessions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static getSalesCashDrawersGetCurrentSession<ThrowOnError extends boolean = false>(options?: Options<GetSalesCashDrawersGetCurrentSessionData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesCashDrawersGetCurrentSessionResponse, unknown, ThrowOnError>({
            url: '/sales/cash-drawers/sessions/current',
            ...options
        });
    }
    
    public static getSalesCashDrawersGetSession<ThrowOnError extends boolean = false>(options: Options<GetSalesCashDrawersGetSessionData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetSalesCashDrawersGetSessionResponse, unknown, ThrowOnError>({
            url: '/sales/cash-drawers/sessions/{sessionId}',
            ...options
        });
    }
    
    public static getSalesCashDrawersGetExpectedCash<ThrowOnError extends boolean = false>(options: Options<GetSalesCashDrawersGetExpectedCashData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetSalesCashDrawersGetExpectedCashResponse, unknown, ThrowOnError>({
            url: '/sales/cash-drawers/sessions/{sessionId}/expected-cash',
            ...options
        });
    }
    
    public static postSalesCashDrawersRecordCloseout<ThrowOnError extends boolean = false>(options: Options<PostSalesCashDrawersRecordCloseoutData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesCashDrawersRecordCloseoutResponse, unknown, ThrowOnError>({
            url: '/sales/cash-drawers/sessions/{sessionId}/closeout',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SalesConfigBookableTypesApi {
    public static getSalesConfigBookableTypesIndex<ThrowOnError extends boolean = false>(options?: Options<GetSalesConfigBookableTypesIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesConfigBookableTypesIndexResponse, unknown, ThrowOnError>({
            url: '/sales/config/bookable-types',
            ...options
        });
    }
    
    public static postSalesConfigBookableTypesCreate<ThrowOnError extends boolean = false>(options: Options<PostSalesConfigBookableTypesCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesConfigBookableTypesCreateResponse, unknown, ThrowOnError>({
            url: '/sales/config/bookable-types',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static deleteSalesConfigBookableTypesDelete<ThrowOnError extends boolean = false>(options: Options<DeleteSalesConfigBookableTypesDeleteData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteSalesConfigBookableTypesDeleteResponse, unknown, ThrowOnError>({
            url: '/sales/config/bookable-types/{id}',
            ...options
        });
    }
    
    public static putSalesConfigBookableTypesUpdate<ThrowOnError extends boolean = false>(options: Options<PutSalesConfigBookableTypesUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutSalesConfigBookableTypesUpdateResponse, unknown, ThrowOnError>({
            url: '/sales/config/bookable-types/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SalesConfigCustomPaymentMethodsApi {
    public static getSalesConfigCustomPaymentMethodsIndex<ThrowOnError extends boolean = false>(options?: Options<GetSalesConfigCustomPaymentMethodsIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesConfigCustomPaymentMethodsIndexResponse, unknown, ThrowOnError>({
            url: '/sales/config/custom-payment-methods',
            ...options
        });
    }
    
    public static postSalesConfigCustomPaymentMethodsCreate<ThrowOnError extends boolean = false>(options: Options<PostSalesConfigCustomPaymentMethodsCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesConfigCustomPaymentMethodsCreateResponse, unknown, ThrowOnError>({
            url: '/sales/config/custom-payment-methods',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static deleteSalesConfigCustomPaymentMethodsDelete<ThrowOnError extends boolean = false>(options: Options<DeleteSalesConfigCustomPaymentMethodsDeleteData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteSalesConfigCustomPaymentMethodsDeleteResponse, unknown, ThrowOnError>({
            url: '/sales/config/custom-payment-methods/{id}',
            ...options
        });
    }
    
    public static putSalesConfigCustomPaymentMethodsUpdate<ThrowOnError extends boolean = false>(options: Options<PutSalesConfigCustomPaymentMethodsUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutSalesConfigCustomPaymentMethodsUpdateResponse, unknown, ThrowOnError>({
            url: '/sales/config/custom-payment-methods/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SalesConfigPaymentAccountsApi {
    public static getSalesConfigPaymentAccountsIndex<ThrowOnError extends boolean = false>(options?: Options<GetSalesConfigPaymentAccountsIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesConfigPaymentAccountsIndexResponse, unknown, ThrowOnError>({
            url: '/sales/config/payments/accounts',
            ...options
        });
    }
    
    public static postSalesConfigPaymentAccountsCreate<ThrowOnError extends boolean = false>(options: Options<PostSalesConfigPaymentAccountsCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesConfigPaymentAccountsCreateResponse, unknown, ThrowOnError>({
            url: '/sales/config/payments/accounts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postSalesConfigPaymentAccountsCreateWithOauthCode<ThrowOnError extends boolean = false>(options: Options<PostSalesConfigPaymentAccountsCreateWithOauthCodeData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesConfigPaymentAccountsCreateWithOauthCodeResponse, unknown, ThrowOnError>({
            url: '/sales/config/payments/accounts/oauth-code',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SalesConfigPaymentOverviewApi {
    public static getSalesConfigPaymentOverviewIndex<ThrowOnError extends boolean = false>(options?: Options<GetSalesConfigPaymentOverviewIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesConfigPaymentOverviewIndexResponse, unknown, ThrowOnError>({
            url: '/sales/config/payments',
            ...options
        });
    }
    
}

export class SalesConfigPaymentTerminalsApi {
    public static getSalesConfigPaymentTerminalsIndex<ThrowOnError extends boolean = false>(options?: Options<GetSalesConfigPaymentTerminalsIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesConfigPaymentTerminalsIndexResponse, unknown, ThrowOnError>({
            url: '/sales/config/payments/terminals',
            ...options
        });
    }
    
    public static postSalesConfigPaymentTerminalsCreate<ThrowOnError extends boolean = false>(options: Options<PostSalesConfigPaymentTerminalsCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesConfigPaymentTerminalsCreateResponse, unknown, ThrowOnError>({
            url: '/sales/config/payments/terminals',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static deleteSalesConfigPaymentTerminalsDelete<ThrowOnError extends boolean = false>(options: Options<DeleteSalesConfigPaymentTerminalsDeleteData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteSalesConfigPaymentTerminalsDeleteResponse, unknown, ThrowOnError>({
            url: '/sales/config/payments/terminals/{id}',
            ...options
        });
    }
    
    public static putSalesConfigPaymentTerminalsUpdate<ThrowOnError extends boolean = false>(options: Options<PutSalesConfigPaymentTerminalsUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutSalesConfigPaymentTerminalsUpdateResponse, unknown, ThrowOnError>({
            url: '/sales/config/payments/terminals/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postSalesConfigPaymentTerminalsClear<ThrowOnError extends boolean = false>(options: Options<PostSalesConfigPaymentTerminalsClearData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesConfigPaymentTerminalsClearResponse, unknown, ThrowOnError>({
            url: '/sales/config/payments/terminals/{id}/clear',
            ...options
        });
    }
    
    public static postSalesConfigPaymentTerminalsCreateConnectionToken<ThrowOnError extends boolean = false>(options?: Options<PostSalesConfigPaymentTerminalsCreateConnectionTokenData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).post<PostSalesConfigPaymentTerminalsCreateConnectionTokenResponse, unknown, ThrowOnError>({
            url: '/sales/config/payments/terminals/connection-token',
            ...options
        });
    }
    
}

export class SalesConfigPaymentTerminalsLocationsApi {
    public static postSalesConfigPaymentTerminalsLocationsCreate<ThrowOnError extends boolean = false>(options: Options<PostSalesConfigPaymentTerminalsLocationsCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesConfigPaymentTerminalsLocationsCreateResponse, unknown, ThrowOnError>({
            url: '/sales/config/payments/terminals/locations',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SalesConfigProductCategoriesApi {
    public static getSalesConfigProductCategoriesIndex<ThrowOnError extends boolean = false>(options?: Options<GetSalesConfigProductCategoriesIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesConfigProductCategoriesIndexResponse, unknown, ThrowOnError>({
            url: '/sales/config/categories',
            ...options
        });
    }
    
    public static postSalesConfigProductCategoriesCreate<ThrowOnError extends boolean = false>(options: Options<PostSalesConfigProductCategoriesCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesConfigProductCategoriesCreateResponse, unknown, ThrowOnError>({
            url: '/sales/config/categories',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static deleteSalesConfigProductCategoriesDelete<ThrowOnError extends boolean = false>(options: Options<DeleteSalesConfigProductCategoriesDeleteData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteSalesConfigProductCategoriesDeleteResponse, unknown, ThrowOnError>({
            url: '/sales/config/categories/{id}',
            ...options
        });
    }
    
    public static putSalesConfigProductCategoriesUpdate<ThrowOnError extends boolean = false>(options: Options<PutSalesConfigProductCategoriesUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutSalesConfigProductCategoriesUpdateResponse, unknown, ThrowOnError>({
            url: '/sales/config/categories/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SalesConfigProductModifiersApi {
    public static getSalesConfigProductModifiersIndex<ThrowOnError extends boolean = false>(options?: Options<GetSalesConfigProductModifiersIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesConfigProductModifiersIndexResponse, unknown, ThrowOnError>({
            url: '/sales/config/product-modifiers',
            ...options
        });
    }
    
    public static postSalesConfigProductModifiersCreate<ThrowOnError extends boolean = false>(options: Options<PostSalesConfigProductModifiersCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesConfigProductModifiersCreateResponse, unknown, ThrowOnError>({
            url: '/sales/config/product-modifiers',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static deleteSalesConfigProductModifiersDelete<ThrowOnError extends boolean = false>(options: Options<DeleteSalesConfigProductModifiersDeleteData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteSalesConfigProductModifiersDeleteResponse, unknown, ThrowOnError>({
            url: '/sales/config/product-modifiers/{id}',
            ...options
        });
    }
    
    public static getSalesConfigProductModifiersGet<ThrowOnError extends boolean = false>(options: Options<GetSalesConfigProductModifiersGetData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetSalesConfigProductModifiersGetResponse, unknown, ThrowOnError>({
            url: '/sales/config/product-modifiers/{id}',
            ...options
        });
    }
    
    public static patchSalesConfigProductModifiersUpdate<ThrowOnError extends boolean = false>(options: Options<PatchSalesConfigProductModifiersUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).patch<PatchSalesConfigProductModifiersUpdateResponse, unknown, ThrowOnError>({
            url: '/sales/config/product-modifiers/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SalesConfigTaxesApi {
    public static getSalesConfigTaxesIndex<ThrowOnError extends boolean = false>(options?: Options<GetSalesConfigTaxesIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesConfigTaxesIndexResponse, unknown, ThrowOnError>({
            url: '/sales/config/taxes',
            ...options
        });
    }
    
}

export class SalesPredefinedDiscountTypesApi {
    public static getSalesPredefinedDiscountTypesIndex<ThrowOnError extends boolean = false>(options?: Options<GetSalesPredefinedDiscountTypesIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesPredefinedDiscountTypesIndexResponse, unknown, ThrowOnError>({
            url: '/sales/config/predefined-discount-types',
            ...options
        });
    }
    
    public static postSalesPredefinedDiscountTypesCreate<ThrowOnError extends boolean = false>(options: Options<PostSalesPredefinedDiscountTypesCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesPredefinedDiscountTypesCreateResponse, unknown, ThrowOnError>({
            url: '/sales/config/predefined-discount-types',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static deleteSalesPredefinedDiscountTypesDelete<ThrowOnError extends boolean = false>(options: Options<DeleteSalesPredefinedDiscountTypesDeleteData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteSalesPredefinedDiscountTypesDeleteResponse, unknown, ThrowOnError>({
            url: '/sales/config/predefined-discount-types/{id}',
            ...options
        });
    }
    
    public static putSalesPredefinedDiscountTypesUpdate<ThrowOnError extends boolean = false>(options: Options<PutSalesPredefinedDiscountTypesUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutSalesPredefinedDiscountTypesUpdateResponse, unknown, ThrowOnError>({
            url: '/sales/config/predefined-discount-types/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SalesFinancialAccountsApi {
    public static getSalesFinancialAccountsIndex<ThrowOnError extends boolean = false>(options?: Options<GetSalesFinancialAccountsIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesFinancialAccountsIndexResponse, unknown, ThrowOnError>({
            url: '/sales/financial/accounts',
            ...options
        });
    }
    
    public static postSalesFinancialAccountsCreate<ThrowOnError extends boolean = false>(options: Options<PostSalesFinancialAccountsCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesFinancialAccountsCreateResponse, unknown, ThrowOnError>({
            url: '/sales/financial/accounts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static deleteSalesFinancialAccountsDelete<ThrowOnError extends boolean = false>(options: Options<DeleteSalesFinancialAccountsDeleteData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteSalesFinancialAccountsDeleteResponse, unknown, ThrowOnError>({
            url: '/sales/financial/accounts/{id}',
            ...options
        });
    }
    
    public static putSalesFinancialAccountsUpdate<ThrowOnError extends boolean = false>(options: Options<PutSalesFinancialAccountsUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutSalesFinancialAccountsUpdateResponse, unknown, ThrowOnError>({
            url: '/sales/financial/accounts/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SalesFinancialDailyCloseoutsApi {
    public static getSalesFinancialDailyCloseoutsIndex<ThrowOnError extends boolean = false>(options?: Options<GetSalesFinancialDailyCloseoutsIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesFinancialDailyCloseoutsIndexResponse, unknown, ThrowOnError>({
            url: '/sales/financial/closeouts',
            ...options
        });
    }
    
}

export class SalesFinancialTransactionsApi {
    public static getSalesFinancialTransactionsIndex<ThrowOnError extends boolean = false>(options?: Options<GetSalesFinancialTransactionsIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesFinancialTransactionsIndexResponse, unknown, ThrowOnError>({
            url: '/sales/financial/transactions',
            ...options
        });
    }
    
}

export class SalesFulfillmentAddressVerificationApi {
    public static postSalesFulfillmentAddressVerificationVerifyAddress<ThrowOnError extends boolean = false>(options: Options<PostSalesFulfillmentAddressVerificationVerifyAddressData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesFulfillmentAddressVerificationVerifyAddressResponse, unknown, ThrowOnError>({
            url: '/sales/fulfillment/address-verification',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SalesFulfillmentConfigApi {
    public static getSalesFulfillmentConfigGet<ThrowOnError extends boolean = false>(options?: Options<GetSalesFulfillmentConfigGetData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesFulfillmentConfigGetResponse, unknown, ThrowOnError>({
            url: '/sales/fulfillment/config',
            ...options
        });
    }
    
    public static putSalesFulfillmentConfigUpdate<ThrowOnError extends boolean = false>(options: Options<PutSalesFulfillmentConfigUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutSalesFulfillmentConfigUpdateResponse, unknown, ThrowOnError>({
            url: '/sales/fulfillment/config',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SalesFulfillmentBoxTypesApi {
    public static getSalesFulfillmentBoxTypesList<ThrowOnError extends boolean = false>(options?: Options<GetSalesFulfillmentBoxTypesListData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesFulfillmentBoxTypesListResponse, unknown, ThrowOnError>({
            url: '/sales/fulfillment/box-types',
            ...options
        });
    }
    
    public static postSalesFulfillmentBoxTypesCreate<ThrowOnError extends boolean = false>(options: Options<PostSalesFulfillmentBoxTypesCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesFulfillmentBoxTypesCreateResponse, unknown, ThrowOnError>({
            url: '/sales/fulfillment/box-types',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static getSalesFulfillmentBoxTypesListPredefined<ThrowOnError extends boolean = false>(options?: Options<GetSalesFulfillmentBoxTypesListPredefinedData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesFulfillmentBoxTypesListPredefinedResponse, unknown, ThrowOnError>({
            url: '/sales/fulfillment/box-types/predefined',
            ...options
        });
    }
    
    public static deleteSalesFulfillmentBoxTypesDelete<ThrowOnError extends boolean = false>(options: Options<DeleteSalesFulfillmentBoxTypesDeleteData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteSalesFulfillmentBoxTypesDeleteResponse, unknown, ThrowOnError>({
            url: '/sales/fulfillment/box-types/{id}',
            ...options
        });
    }
    
    public static postSalesFulfillmentBoxTypesUpdate<ThrowOnError extends boolean = false>(options: Options<PostSalesFulfillmentBoxTypesUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesFulfillmentBoxTypesUpdateResponse, unknown, ThrowOnError>({
            url: '/sales/fulfillment/box-types/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SalesFulfillmentEasyPostWebhookPublicApi {
    public static postSalesFulfillmentEasyPostWebhookPublicPost<ThrowOnError extends boolean = false>(options: Options<PostSalesFulfillmentEasyPostWebhookPublicPostData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesFulfillmentEasyPostWebhookPublicPostResponse, unknown, ThrowOnError>({
            url: '/public/sales/fulfillment/easypost-webhook',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SalesFulfillmentOrdersApi {
    public static putSalesFulfillmentOrdersUpdateFulfillment<ThrowOnError extends boolean = false>(options: Options<PutSalesFulfillmentOrdersUpdateFulfillmentData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutSalesFulfillmentOrdersUpdateFulfillmentResponse, unknown, ThrowOnError>({
            url: '/sales/fulfillment/orders/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SalesFulfillmentShipmentBatchesApi {
    public static getSalesFulfillmentShipmentBatchesGetBatches<ThrowOnError extends boolean = false>(options?: Options<GetSalesFulfillmentShipmentBatchesGetBatchesData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesFulfillmentShipmentBatchesGetBatchesResponse, unknown, ThrowOnError>({
            url: '/sales/fulfillment/shipment-batches',
            ...options
        });
    }
    
    public static postSalesFulfillmentShipmentBatchesCreateBatch<ThrowOnError extends boolean = false>(options: Options<PostSalesFulfillmentShipmentBatchesCreateBatchData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesFulfillmentShipmentBatchesCreateBatchResponse, unknown, ThrowOnError>({
            url: '/sales/fulfillment/shipment-batches',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static deleteSalesFulfillmentShipmentBatchesRemoveOrdersFromBatch<ThrowOnError extends boolean = false>(options: Options<DeleteSalesFulfillmentShipmentBatchesRemoveOrdersFromBatchData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteSalesFulfillmentShipmentBatchesRemoveOrdersFromBatchResponse, unknown, ThrowOnError>({
            url: '/sales/fulfillment/shipment-batches/{id}/orders',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postSalesFulfillmentShipmentBatchesAddOrdersToBatch<ThrowOnError extends boolean = false>(options: Options<PostSalesFulfillmentShipmentBatchesAddOrdersToBatchData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesFulfillmentShipmentBatchesAddOrdersToBatchResponse, unknown, ThrowOnError>({
            url: '/sales/fulfillment/shipment-batches/{id}/orders',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static getSalesFulfillmentShipmentBatchesGetPackingSlips<ThrowOnError extends boolean = false>(options: Options<GetSalesFulfillmentShipmentBatchesGetPackingSlipsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
            url: '/sales/fulfillment/shipment-batches/{id}/packing-slips',
            ...options
        });
    }
    
}

export class SalesFulfillmentShipmentPickupsApi {
    public static getSalesFulfillmentShipmentPickupsGetPickups<ThrowOnError extends boolean = false>(options?: Options<GetSalesFulfillmentShipmentPickupsGetPickupsData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesFulfillmentShipmentPickupsGetPickupsResponse, unknown, ThrowOnError>({
            url: '/sales/fulfillment/shipment-pickups',
            ...options
        });
    }
    
    public static postSalesFulfillmentShipmentPickupsAddShipmentByBarcode<ThrowOnError extends boolean = false>(options: Options<PostSalesFulfillmentShipmentPickupsAddShipmentByBarcodeData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesFulfillmentShipmentPickupsAddShipmentByBarcodeResponse, unknown, ThrowOnError>({
            url: '/sales/fulfillment/shipment-pickups/{id}/shipments/barcode',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postSalesFulfillmentShipmentPickupsAddShipmentById<ThrowOnError extends boolean = false>(options: Options<PostSalesFulfillmentShipmentPickupsAddShipmentByIdData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesFulfillmentShipmentPickupsAddShipmentByIdResponse, unknown, ThrowOnError>({
            url: '/sales/fulfillment/shipment-pickups/{id}/shipments/{shipmentId}',
            ...options
        });
    }
    
}

export class SalesFulfillmentShippingCalculatorApi {
    public static postSalesFulfillmentShippingCalculatorCalculateShipping<ThrowOnError extends boolean = false>(options: Options<PostSalesFulfillmentShippingCalculatorCalculateShippingData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesFulfillmentShippingCalculatorCalculateShippingResponse, unknown, ThrowOnError>({
            url: '/sales/fulfillment/shipping/calculate',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postSalesFulfillmentShippingCalculatorRecalculateShipping<ThrowOnError extends boolean = false>(options: Options<PostSalesFulfillmentShippingCalculatorRecalculateShippingData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesFulfillmentShippingCalculatorRecalculateShippingResponse, unknown, ThrowOnError>({
            url: '/sales/fulfillment/shipping/{id}/recalculate',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SalesFulfillmentShippingLabelApi {
    public static getSalesFulfillmentShippingLabelGetPackingSlip<ThrowOnError extends boolean = false>(options: Options<GetSalesFulfillmentShippingLabelGetPackingSlipData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
            url: '/sales/fulfillment/shipping/{id}/packing-slip/{packageIdx}',
            ...options
        });
    }
    
    public static getSalesFulfillmentShippingLabelGetLabel<ThrowOnError extends boolean = false>(options: Options<GetSalesFulfillmentShippingLabelGetLabelData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
            url: '/sales/fulfillment/shipping/{id}/label/{packageIdx}',
            ...options
        });
    }
    
    public static postSalesFulfillmentShippingLabelPurchaseLabel<ThrowOnError extends boolean = false>(options: Options<PostSalesFulfillmentShippingLabelPurchaseLabelData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesFulfillmentShippingLabelPurchaseLabelResponse, unknown, ThrowOnError>({
            url: '/sales/fulfillment/shipping/{id}/label/{packageIdx}/purchase',
            ...options
        });
    }
    
    public static postSalesFulfillmentShippingLabelPrintLabel<ThrowOnError extends boolean = false>(options: Options<PostSalesFulfillmentShippingLabelPrintLabelData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesFulfillmentShippingLabelPrintLabelResponse, unknown, ThrowOnError>({
            url: '/sales/fulfillment/shipping/{id}/label/{packageIdx}/print',
            ...options
        });
    }
    
    public static postSalesFulfillmentShippingLabelRefundLabel<ThrowOnError extends boolean = false>(options: Options<PostSalesFulfillmentShippingLabelRefundLabelData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesFulfillmentShippingLabelRefundLabelResponse, unknown, ThrowOnError>({
            url: '/sales/fulfillment/shipping/{id}/label/{packageIdx}/refund',
            ...options
        });
    }
    
}

export class SalesGiftCardsApi {
    public static getSalesGiftCardsIndex<ThrowOnError extends boolean = false>(options?: Options<GetSalesGiftCardsIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesGiftCardsIndexResponse, unknown, ThrowOnError>({
            url: '/sales/gift-cards',
            ...options
        });
    }
    
    public static getSalesGiftCardsLookup<ThrowOnError extends boolean = false>(options: Options<GetSalesGiftCardsLookupData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetSalesGiftCardsLookupResponse, unknown, ThrowOnError>({
            url: '/sales/gift-cards/lookup',
            ...options
        });
    }
    
    public static postSalesGiftCardsDeliver<ThrowOnError extends boolean = false>(options: Options<PostSalesGiftCardsDeliverData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesGiftCardsDeliverResponse, unknown, ThrowOnError>({
            url: '/sales/gift-cards/{id}/deliver',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SalesGiftCardsPublicRenderApi {
    public static getSalesGiftCardsPublicRenderRenderGiftCard<ThrowOnError extends boolean = false>(options: Options<GetSalesGiftCardsPublicRenderRenderGiftCardData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
            url: '/public/sales/gift-cards/{id}/render',
            ...options
        });
    }
    
    public static getSalesGiftCardsPublicRenderRenderGiftCardEmail<ThrowOnError extends boolean = false>(options: Options<GetSalesGiftCardsPublicRenderRenderGiftCardEmailData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
            url: '/public/sales/gift-cards/{id}/render-email',
            ...options
        });
    }
    
}

export class SalesIntegrationsQboConnectionsApi {
    public static deleteSalesIntegrationsQboConnectionsDeleteIntegration<ThrowOnError extends boolean = false>(options?: Options<DeleteSalesIntegrationsQboConnectionsDeleteIntegrationData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).delete<DeleteSalesIntegrationsQboConnectionsDeleteIntegrationResponse, unknown, ThrowOnError>({
            url: '/sales/integrations/qbo/connections',
            ...options
        });
    }
    
    public static getSalesIntegrationsQboConnectionsGetIntegrations<ThrowOnError extends boolean = false>(options?: Options<GetSalesIntegrationsQboConnectionsGetIntegrationsData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesIntegrationsQboConnectionsGetIntegrationsResponse, unknown, ThrowOnError>({
            url: '/sales/integrations/qbo/connections',
            ...options
        });
    }
    
    public static postSalesIntegrationsQboConnectionsCreateIntegration<ThrowOnError extends boolean = false>(options: Options<PostSalesIntegrationsQboConnectionsCreateIntegrationData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesIntegrationsQboConnectionsCreateIntegrationResponse, unknown, ThrowOnError>({
            url: '/sales/integrations/qbo/connections',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static putSalesIntegrationsQboConnectionsUpdateIntegration<ThrowOnError extends boolean = false>(options: Options<PutSalesIntegrationsQboConnectionsUpdateIntegrationData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutSalesIntegrationsQboConnectionsUpdateIntegrationResponse, unknown, ThrowOnError>({
            url: '/sales/integrations/qbo/connections',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static getSalesIntegrationsQboConnectionsGetQboAccounts<ThrowOnError extends boolean = false>(options?: Options<GetSalesIntegrationsQboConnectionsGetQboAccountsData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesIntegrationsQboConnectionsGetQboAccountsResponse, unknown, ThrowOnError>({
            url: '/sales/integrations/qbo/connections/qb-accounts',
            ...options
        });
    }
    
}

export class SalesLayoutsApi {
    public static getSalesLayoutsGetDefault<ThrowOnError extends boolean = false>(options?: Options<GetSalesLayoutsGetDefaultData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesLayoutsGetDefaultResponse, unknown, ThrowOnError>({
            url: '/sales/layouts/default',
            ...options
        });
    }
    
}

export class SalesMembershipCreditPoolsApi {
    public static getSalesMembershipCreditPoolsIndex<ThrowOnError extends boolean = false>(options?: Options<GetSalesMembershipCreditPoolsIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesMembershipCreditPoolsIndexResponse, unknown, ThrowOnError>({
            url: '/sales/membership-credit-pools',
            ...options
        });
    }
    
    public static postSalesMembershipCreditPoolsCreate<ThrowOnError extends boolean = false>(options: Options<PostSalesMembershipCreditPoolsCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesMembershipCreditPoolsCreateResponse, unknown, ThrowOnError>({
            url: '/sales/membership-credit-pools',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static deleteSalesMembershipCreditPoolsDelete<ThrowOnError extends boolean = false>(options: Options<DeleteSalesMembershipCreditPoolsDeleteData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteSalesMembershipCreditPoolsDeleteResponse, unknown, ThrowOnError>({
            url: '/sales/membership-credit-pools/{id}',
            ...options
        });
    }
    
    public static getSalesMembershipCreditPoolsShow<ThrowOnError extends boolean = false>(options: Options<GetSalesMembershipCreditPoolsShowData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetSalesMembershipCreditPoolsShowResponse, unknown, ThrowOnError>({
            url: '/sales/membership-credit-pools/{id}',
            ...options
        });
    }
    
    public static putSalesMembershipCreditPoolsUpdate<ThrowOnError extends boolean = false>(options: Options<PutSalesMembershipCreditPoolsUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutSalesMembershipCreditPoolsUpdateResponse, unknown, ThrowOnError>({
            url: '/sales/membership-credit-pools/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SalesMembershipTypeCreditPoolGrantsApi {
    public static getSalesMembershipTypeCreditPoolGrantsIndex<ThrowOnError extends boolean = false>(options?: Options<GetSalesMembershipTypeCreditPoolGrantsIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesMembershipTypeCreditPoolGrantsIndexResponse, unknown, ThrowOnError>({
            url: '/sales/membership-types/credit-pool-grants',
            ...options
        });
    }
    
    public static postSalesMembershipTypeCreditPoolGrantsCreate<ThrowOnError extends boolean = false>(options: Options<PostSalesMembershipTypeCreditPoolGrantsCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesMembershipTypeCreditPoolGrantsCreateResponse, unknown, ThrowOnError>({
            url: '/sales/membership-types/credit-pool-grants',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static deleteSalesMembershipTypeCreditPoolGrantsDelete<ThrowOnError extends boolean = false>(options: Options<DeleteSalesMembershipTypeCreditPoolGrantsDeleteData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteSalesMembershipTypeCreditPoolGrantsDeleteResponse, unknown, ThrowOnError>({
            url: '/sales/membership-types/credit-pool-grants/{id}',
            ...options
        });
    }
    
    public static getSalesMembershipTypeCreditPoolGrantsShow<ThrowOnError extends boolean = false>(options: Options<GetSalesMembershipTypeCreditPoolGrantsShowData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetSalesMembershipTypeCreditPoolGrantsShowResponse, unknown, ThrowOnError>({
            url: '/sales/membership-types/credit-pool-grants/{id}',
            ...options
        });
    }
    
    public static putSalesMembershipTypeCreditPoolGrantsUpdate<ThrowOnError extends boolean = false>(options: Options<PutSalesMembershipTypeCreditPoolGrantsUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutSalesMembershipTypeCreditPoolGrantsUpdateResponse, unknown, ThrowOnError>({
            url: '/sales/membership-types/credit-pool-grants/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SalesMembershipTypeDiscountsApi {
    public static getSalesMembershipTypeDiscountsIndex<ThrowOnError extends boolean = false>(options?: Options<GetSalesMembershipTypeDiscountsIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesMembershipTypeDiscountsIndexResponse, unknown, ThrowOnError>({
            url: '/sales/membership-types/discounts',
            ...options
        });
    }
    
    public static postSalesMembershipTypeDiscountsCreate<ThrowOnError extends boolean = false>(options: Options<PostSalesMembershipTypeDiscountsCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesMembershipTypeDiscountsCreateResponse, unknown, ThrowOnError>({
            url: '/sales/membership-types/discounts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static deleteSalesMembershipTypeDiscountsDelete<ThrowOnError extends boolean = false>(options: Options<DeleteSalesMembershipTypeDiscountsDeleteData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteSalesMembershipTypeDiscountsDeleteResponse, unknown, ThrowOnError>({
            url: '/sales/membership-types/discounts/{id}',
            ...options
        });
    }
    
    public static getSalesMembershipTypeDiscountsShow<ThrowOnError extends boolean = false>(options: Options<GetSalesMembershipTypeDiscountsShowData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetSalesMembershipTypeDiscountsShowResponse, unknown, ThrowOnError>({
            url: '/sales/membership-types/discounts/{id}',
            ...options
        });
    }
    
    public static putSalesMembershipTypeDiscountsUpdate<ThrowOnError extends boolean = false>(options: Options<PutSalesMembershipTypeDiscountsUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutSalesMembershipTypeDiscountsUpdateResponse, unknown, ThrowOnError>({
            url: '/sales/membership-types/discounts/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SalesMembershipTypesApi {
    public static getSalesMembershipTypesIndex<ThrowOnError extends boolean = false>(options?: Options<GetSalesMembershipTypesIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesMembershipTypesIndexResponse, unknown, ThrowOnError>({
            url: '/sales/membership-types',
            ...options
        });
    }
    
    public static getSalesMembershipTypesShow<ThrowOnError extends boolean = false>(options: Options<GetSalesMembershipTypesShowData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetSalesMembershipTypesShowResponse, unknown, ThrowOnError>({
            url: '/sales/membership-types/{id}',
            ...options
        });
    }
    
}

export class SalesProductsApi {
    public static getSalesProductsIndex<ThrowOnError extends boolean = false>(options?: Options<GetSalesProductsIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesProductsIndexResponse, unknown, ThrowOnError>({
            url: '/sales/products',
            ...options
        });
    }
    
    public static postSalesProductsCreate<ThrowOnError extends boolean = false>(options: Options<PostSalesProductsCreateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesProductsCreateResponse, unknown, ThrowOnError>({
            url: '/sales/products',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static deleteSalesProductsDelete<ThrowOnError extends boolean = false>(options: Options<DeleteSalesProductsDeleteData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteSalesProductsDeleteResponse, unknown, ThrowOnError>({
            url: '/sales/products/{id}',
            ...options
        });
    }
    
    public static getSalesProductsShow<ThrowOnError extends boolean = false>(options: Options<GetSalesProductsShowData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetSalesProductsShowResponse, unknown, ThrowOnError>({
            url: '/sales/products/{id}',
            ...options
        });
    }
    
    public static putSalesProductsUpdate<ThrowOnError extends boolean = false>(options: Options<PutSalesProductsUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutSalesProductsUpdateResponse, unknown, ThrowOnError>({
            url: '/sales/products/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SalesEcommProductsPublicApi {
    public static getSalesEcommProductsPublicIndex<ThrowOnError extends boolean = false>(options: Options<GetSalesEcommProductsPublicIndexData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetSalesEcommProductsPublicIndexResponse, unknown, ThrowOnError>({
            url: '/public/sales/ecomm/products/{tenantId}',
            ...options
        });
    }
    
    public static getSalesEcommProductsPublicShow<ThrowOnError extends boolean = false>(options: Options<GetSalesEcommProductsPublicShowData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetSalesEcommProductsPublicShowResponse, unknown, ThrowOnError>({
            url: '/public/sales/ecomm/products/{tenantId}/{slug}',
            ...options
        });
    }
    
}

export class SalesSalespointsApi {
    public static getSalesSalespointsGetSelf<ThrowOnError extends boolean = false>(options?: Options<GetSalesSalespointsGetSelfData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesSalespointsGetSelfResponse, unknown, ThrowOnError>({
            url: '/sales/salespoints/self',
            ...options
        });
    }
    
    public static postSalesSalespointsOpenDrawer<ThrowOnError extends boolean = false>(options: Options<PostSalesSalespointsOpenDrawerData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesSalespointsOpenDrawerResponse, unknown, ThrowOnError>({
            url: '/sales/salespoints/{id}/open-drawer',
            ...options
        });
    }
    
}

export class SalesBookingSummaryApi {
    public static getSalesBookingSummaryGetBookings<ThrowOnError extends boolean = false>(options?: Options<GetSalesBookingSummaryGetBookingsData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesBookingSummaryGetBookingsResponse, unknown, ThrowOnError>({
            url: '/sales/booking-summary',
            ...options
        });
    }
    
}

export class SalesTabsApi {
    public static getSalesTabsList<ThrowOnError extends boolean = false>(options?: Options<GetSalesTabsListData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesTabsListResponse, unknown, ThrowOnError>({
            url: '/sales/tabs',
            ...options
        });
    }
    
    public static deleteSalesTabsDeleteTab<ThrowOnError extends boolean = false>(options: Options<DeleteSalesTabsDeleteTabData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteSalesTabsDeleteTabResponse, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static getSalesTabsGet<ThrowOnError extends boolean = false>(options: Options<GetSalesTabsGetData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetSalesTabsGetResponse, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}',
            ...options
        });
    }
    
    public static putSalesTabsUpdateTab<ThrowOnError extends boolean = false>(options: Options<PutSalesTabsUpdateTabData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutSalesTabsUpdateTabResponse, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postSalesTabsCreateItem<ThrowOnError extends boolean = false>(options: Options<PostSalesTabsCreateItemData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesTabsCreateItemResponse, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}/items',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static deleteSalesTabsDeleteItem<ThrowOnError extends boolean = false>(options: Options<DeleteSalesTabsDeleteItemData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).delete<DeleteSalesTabsDeleteItemResponse, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}/items/{itemId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static putSalesTabsUpdateItem<ThrowOnError extends boolean = false>(options: Options<PutSalesTabsUpdateItemData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutSalesTabsUpdateItemResponse, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}/items/{itemId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postSalesTabsTouch<ThrowOnError extends boolean = false>(options: Options<PostSalesTabsTouchData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesTabsTouchResponse, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}/touch',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SalesTabsExportApi {
    public static getSalesTabsExportExport<ThrowOnError extends boolean = false>(options?: Options<GetSalesTabsExportExportData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
            url: '/sales/tabs/export',
            ...options
        });
    }
    
}

export class SalesTabPaymentsApi {
    public static postSalesTabPaymentsSetupCcPaymentIntent<ThrowOnError extends boolean = false>(options: Options<PostSalesTabPaymentsSetupCcPaymentIntentData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesTabPaymentsSetupCcPaymentIntentResponse, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}/payments/setup-cc',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postSalesTabPaymentsSetupCcTerminalPaymentIntent<ThrowOnError extends boolean = false>(options: Options<PostSalesTabPaymentsSetupCcTerminalPaymentIntentData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesTabPaymentsSetupCcTerminalPaymentIntentResponse, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}/payments/setup-cc-terminal',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postSalesTabPaymentsConfirmPaymentIntent<ThrowOnError extends boolean = false>(options: Options<PostSalesTabPaymentsConfirmPaymentIntentData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesTabPaymentsConfirmPaymentIntentResponse, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}/payments/confirm-payment-intent',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postSalesTabPaymentsPayWithConfirmationToken<ThrowOnError extends boolean = false>(options: Options<PostSalesTabPaymentsPayWithConfirmationTokenData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesTabPaymentsPayWithConfirmationTokenResponse, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}/payments/pay-with-confirmation-token',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postSalesTabPaymentsPayWithMethod<ThrowOnError extends boolean = false>(options: Options<PostSalesTabPaymentsPayWithMethodData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesTabPaymentsPayWithMethodResponse, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}/payments/pay-with-method',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postSalesTabPaymentsPayWithCash<ThrowOnError extends boolean = false>(options: Options<PostSalesTabPaymentsPayWithCashData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesTabPaymentsPayWithCashResponse, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}/payments/pay-with-cash',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postSalesTabPaymentsPayWithCheck<ThrowOnError extends boolean = false>(options: Options<PostSalesTabPaymentsPayWithCheckData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesTabPaymentsPayWithCheckResponse, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}/payments/pay-with-check',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postSalesTabPaymentsPayWithGiftCard<ThrowOnError extends boolean = false>(options: Options<PostSalesTabPaymentsPayWithGiftCardData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesTabPaymentsPayWithGiftCardResponse, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}/payments/pay-with-gift-card',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postSalesTabPaymentsPayWithCustom<ThrowOnError extends boolean = false>(options: Options<PostSalesTabPaymentsPayWithCustomData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesTabPaymentsPayWithCustomResponse, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}/payments/pay-with-custom',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postSalesTabPaymentsRefundPayment<ThrowOnError extends boolean = false>(options: Options<PostSalesTabPaymentsRefundPaymentData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesTabPaymentsRefundPaymentResponse, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}/payments/{paymentId}/refund',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postSalesTabPaymentsFinalizeZeroRemainderTab<ThrowOnError extends boolean = false>(options: Options<PostSalesTabPaymentsFinalizeZeroRemainderTabData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesTabPaymentsFinalizeZeroRemainderTabResponse, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}/payments/finalize',
            ...options
        });
    }
    
    public static postSalesTabPaymentsCapturePayment<ThrowOnError extends boolean = false>(options: Options<PostSalesTabPaymentsCapturePaymentData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesTabPaymentsCapturePaymentResponse, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}/payments/{paymentId}/capture',
            ...options
        });
    }
    
}

export class SalesTabReceiptsApi {
    public static getSalesTabReceiptsGetAuthenticatedReceipt<ThrowOnError extends boolean = false>(options: Options<GetSalesTabReceiptsGetAuthenticatedReceiptData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}/receipt',
            ...options
        });
    }
    
    public static postSalesTabReceiptsSendReceipt<ThrowOnError extends boolean = false>(options: Options<PostSalesTabReceiptsSendReceiptData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesTabReceiptsSendReceiptResponse, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}/receipt',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static getSalesTabReceiptsGetPublicReceiptByToken<ThrowOnError extends boolean = false>(options: Options<GetSalesTabReceiptsGetPublicReceiptByTokenData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
            url: '/public/sales/tabs/by-token/receipt',
            ...options
        });
    }
    
    public static getSalesTabReceiptsGetPublicReceipt<ThrowOnError extends boolean = false>(options: Options<GetSalesTabReceiptsGetPublicReceiptData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
            url: '/public/sales/tabs/{tabId}/receipt',
            ...options
        });
    }
    
    public static getSalesTabReceiptsGetPublicReceiptPdf<ThrowOnError extends boolean = false>(options: Options<GetSalesTabReceiptsGetPublicReceiptPdfData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
            url: '/public/sales/tabs/{tabId}/receipt/pdf',
            ...options
        });
    }
    
}

export class SalesTabPostSaleUpdatesApi {
    public static postSalesTabPostSaleUpdatesOpenRevision<ThrowOnError extends boolean = false>(options: Options<PostSalesTabPostSaleUpdatesOpenRevisionData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesTabPostSaleUpdatesOpenRevisionResponse, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}/revision/open',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postSalesTabPostSaleUpdatesFinalizeRevision<ThrowOnError extends boolean = false>(options: Options<PostSalesTabPostSaleUpdatesFinalizeRevisionData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesTabPostSaleUpdatesFinalizeRevisionResponse, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}/revision/finalize',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postSalesTabPostSaleUpdatesRevertRevision<ThrowOnError extends boolean = false>(options: Options<PostSalesTabPostSaleUpdatesRevertRevisionData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesTabPostSaleUpdatesRevertRevisionResponse, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}/revision/revert',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postSalesTabPostSaleUpdatesRefundTab<ThrowOnError extends boolean = false>(options: Options<PostSalesTabPostSaleUpdatesRefundTabData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesTabPostSaleUpdatesRefundTabResponse, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}/refund',
            ...options
        });
    }
    
    public static postSalesTabPostSaleUpdatesAdjustTab<ThrowOnError extends boolean = false>(options: Options<PostSalesTabPostSaleUpdatesAdjustTabData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesTabPostSaleUpdatesAdjustTabResponse, unknown, ThrowOnError>({
            url: '/sales/tabs/{tabId}/adjust',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SalesStripeWebhookPublicApi {
    public static postSalesStripeWebhookPublicHandle<ThrowOnError extends boolean = false>(options?: Options<PostSalesStripeWebhookPublicHandleData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
            url: '/public/sales/stripe/webhook',
            ...options
        });
    }
    
}

export class SalesReportsApi {
    public static postSalesReportsGetData<ThrowOnError extends boolean = false>(options: Options<PostSalesReportsGetDataData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesReportsGetDataResponse, unknown, ThrowOnError>({
            url: '/sales/reports/data',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class SalesXCrmMembershipsApi {
    public static getSalesXCrmMembershipsIndex<ThrowOnError extends boolean = false>(options?: Options<GetSalesXCrmMembershipsIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetSalesXCrmMembershipsIndexResponse, unknown, ThrowOnError>({
            url: '/sales/x-crm/memberships',
            ...options
        });
    }
    
    public static getSalesXCrmMembershipsContactIndex<ThrowOnError extends boolean = false>(options: Options<GetSalesXCrmMembershipsContactIndexData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetSalesXCrmMembershipsContactIndexResponse, unknown, ThrowOnError>({
            url: '/sales/x-crm/{contactId}/memberships',
            ...options
        });
    }
    
    public static putSalesXCrmMembershipsUpdate<ThrowOnError extends boolean = false>(options: Options<PutSalesXCrmMembershipsUpdateData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutSalesXCrmMembershipsUpdateResponse, unknown, ThrowOnError>({
            url: '/sales/x-crm/{contactId}/memberships/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static postSalesXCrmMembershipsPreviewChange<ThrowOnError extends boolean = false>(options: Options<PostSalesXCrmMembershipsPreviewChangeData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PostSalesXCrmMembershipsPreviewChangeResponse, unknown, ThrowOnError>({
            url: '/sales/x-crm/{contactId}/memberships/{id}/preview-change',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static getSalesXCrmMembershipsGetRenewals<ThrowOnError extends boolean = false>(options: Options<GetSalesXCrmMembershipsGetRenewalsData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetSalesXCrmMembershipsGetRenewalsResponse, unknown, ThrowOnError>({
            url: '/sales/x-crm/{contactId}/memberships/{id}/renewals',
            ...options
        });
    }
    
    public static getSalesXCrmMembershipsGetDiscountDetail<ThrowOnError extends boolean = false>(options: Options<GetSalesXCrmMembershipsGetDiscountDetailData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetSalesXCrmMembershipsGetDiscountDetailResponse, unknown, ThrowOnError>({
            url: '/sales/x-crm/{contactId}/memberships/{id}/discounts',
            ...options
        });
    }
    
    public static getSalesXCrmMembershipsGetCreditPoolDetail<ThrowOnError extends boolean = false>(options: Options<GetSalesXCrmMembershipsGetCreditPoolDetailData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<GetSalesXCrmMembershipsGetCreditPoolDetailResponse, unknown, ThrowOnError>({
            url: '/sales/x-crm/{contactId}/memberships/{id}/credit-pools',
            ...options
        });
    }
    
    public static putSalesXCrmMembershipsUpdateDiscountPeriodDiscount<ThrowOnError extends boolean = false>(options: Options<PutSalesXCrmMembershipsUpdateDiscountPeriodDiscountData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutSalesXCrmMembershipsUpdateDiscountPeriodDiscountResponse, unknown, ThrowOnError>({
            url: '/sales/x-crm/{contactId}/memberships/{id}/discount-periods/{periodIdx}/discounts/{membershipTypeDiscountId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static putSalesXCrmMembershipsUpdateCreditPoolBalance<ThrowOnError extends boolean = false>(options: Options<PutSalesXCrmMembershipsUpdateCreditPoolBalanceData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).put<PutSalesXCrmMembershipsUpdateCreditPoolBalanceResponse, unknown, ThrowOnError>({
            url: '/sales/x-crm/{contactId}/memberships/{id}/discount-periods/{periodIdx}/credit-pools/{creditPoolId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class HealthcheckApi {
    public static getHealthcheckIndex<ThrowOnError extends boolean = false>(options?: Options<GetHealthcheckIndexData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetHealthcheckIndexResponse, unknown, ThrowOnError>({
            url: '/healthz',
            ...options
        });
    }
    
}